import { defaultLocale } from "./locales/en-US.js";

export const supportedLocales = [defaultLocale] as const;

export type SupportedLocale = (typeof supportedLocales)[number];

export interface LocaleResolutionInput {
  requestedLocale?: string | null;
  supportedLocales?: readonly SupportedLocale[];
  fallbackLocale?: SupportedLocale;
}

export function resolveLocale(
  input: LocaleResolutionInput = {},
): SupportedLocale {
  const supported = input.supportedLocales ?? supportedLocales;
  const fallback = input.fallbackLocale ?? defaultLocale;
  const requested = normalizeLocaleCode(input.requestedLocale);

  if (requested && supported.includes(requested as SupportedLocale)) {
    return requested as SupportedLocale;
  }

  const requestedLanguage = requested?.split("-")[0];

  if (requestedLanguage) {
    const matched = supported.find((locale) => locale.split("-")[0] === requestedLanguage);

    if (matched) {
      return matched;
    }
  }

  return supported.includes(fallback) ? fallback : defaultLocale;
}

export function normalizeLocaleCode(locale: string | null | undefined): string | undefined {
  if (!locale) {
    return undefined;
  }

  const trimmed = locale.trim();

  if (!trimmed) {
    return undefined;
  }

  const normalized = trimmed.replace("_", "-");

  if (normalized === defaultLocale) {
    return defaultLocale;
  }

  return normalized;
}
